import React, { useState } from 'react';
import './ComplianceMonitoring.scss';
import { multiviewChannels, playerSlots } from './ComplianceMonitoring.data';
import PlayerGrid from './PlayerGrid';

const ComplianceMonitoring: React.FC = () => {
  const [channelByPlayer, setChannelByPlayer] = useState<Record<string, string>>(() => {
    const initial: Record<string, string> = {};
    playerSlots.forEach((slot, index) => {
      const channel = multiviewChannels[index % multiviewChannels.length];
      initial[slot.id] = channel?.url ?? '';
    });
    return initial;
  });

  const handleChannelChange = (id: string, value: string) => {
    setChannelByPlayer((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <div className="compliance-player">
        <div className="compliance-player__left">
          <PlayerGrid
            playerSlots={playerSlots}
            channels={multiviewChannels}
            channelByPlayer={channelByPlayer}
            onChannelChange={handleChannelChange}
          />
        </div>
    </div>
  );
};

export default ComplianceMonitoring;
